import React from 'react';
import { injectIntl } from 'react-intl';
import { NSchange, i18nIntl, cleanFieldProps } from '../../lib/ep.js';

import FieldWrapper from './FieldWrapper';
import Input from './Input.js';

export const SelectGroup = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const change = (e) => {
		if(props.change != undefined) props.change(props.name, e.target.value);
	};

	const autotranslate_options = props?.autotranslate_options ?? true;
	const name = props?.name ?? false;
	const disabled = props?.disabled ?? false;

	const wrapper_props = cleanFieldProps(props);

	let value = props?.default ?? false;
	if(props.model != undefined) value = NSchange(props.model, props.name);
	if(props.value) value = props.value;

	let field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField disabledItem');

	return (
		<FieldWrapper type='select' {...wrapper_props} display_error_at_bottom={true}>
			<select
				class={field_class.join(" ")}
				name={name}
				id={props.id}
				onChange={(e) => change(e)}
				style={props.style}
				value={value}
				disabled={disabled}
			>
				{props.values.length > 0 && props.values.map((group, gindex) => {
					if(group.label !== false && group.items.length <= 0) return null;
					if(group.label === false) {
						return (
							group.items.map((v, index) => {
								const option_props = { value:v.k, key:`${name}${v.k}${index}` };
								if(v.disabled != undefined && v.disabled) option_props.disabled = true;
								return (
									<option
										{...option_props}
									>{(v.v != '' && v.v != undefined && autotranslate_options) ? i18n(v.v) : v.v}</option>
								)
							})
						)
					}

					return (
						<optgroup key={`gindex-${gindex}`} label={group?.label ?? `${i18n("Section")} #${gindex + 1}`}>
							{group.items.map((v, index) => {
								let option_props = { value:v.k, key:`${name}${v.k}${index}` };
								if(v.disabled != undefined && v.disabled) option_props.disabled = true;
								return (
									<option {...option_props}>{(v.v != '' && v.v != undefined && autotranslate_options) ? i18n(v.v) : v.v}</option>
								)
							})}
						</optgroup>
					)
				})}
			</select>
		</FieldWrapper>
	);
}

export const ForcedSelect = injectIntl((props) => {
	const values = props.values.filter(option=>(option.k != ''));
	
	if (values.length == 1) {
		return <Input {...props} disabled={true} value={values[0].v}>{props.children}</Input>
	}
	return <Select {...props}/>
});

const Select = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const change = (e) => {
		if(props.change != undefined) props.change(props.name, e.target.value);
	};

	const autotranslate_options = props?.autotranslate_options ?? true;
	const is_fake = props?.is_fake ?? false;
	const name = props?.name ?? false;
	const disabled = props?.disabled ?? false;

	const wrapper_props = cleanFieldProps(props);

	let value = props?.default ?? false;
	if(props.model != undefined) value = NSchange(props.model, props.name);
	if(props.value) value = props.value;

	let field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField disabledItem');
	if(props.field_extra_classes != undefined) field_class.push(props.field_extra_classes);

	return (
		<FieldWrapper type='select' {...wrapper_props} display_error_at_bottom={true}>
			<select
				class={field_class.join(" ")}
				name={name}
				id={props?.id ?? props.name}
				onChange={(e) => change(e)}
				style={props.style}
				tabIndex={(is_fake) ? -1 : null}
				value={value}
				disabled={disabled}
			>
				{!is_fake && props.values.length > 0 && props.values.map((v, index) => {
					if(v?.hide ?? false) return null;

					const option_props = { value:v.k, key:`${name}${v.k}${index}` };
					if(v.disabled != undefined && v.disabled) option_props.disabled = true;
					if(v.selected != undefined && v.selected) option_props.selected = true;

					return (
						<option
							{...option_props}
						>{(v.v != '' && v.v != undefined && autotranslate_options) ? i18n(v.v) : v.v}</option>
					)
				})}
			</select>

			{props.overlapped_content}
		</FieldWrapper>
	);
}

export default injectIntl(Select);